import React, { useState } from 'react'
import posed, { PoseGroup } from 'react-pose'
import OrderInfoCard from '../components/OrderInfoCard'
import BaySelector from '../components/BaySelector'
import { UNAVAILABLE_BAY_ID } from '../core/constants'

const dataLayer = window.dataLayer
const env = process.env.REACT_APP_ENV

const bays = [
  { id: 'Bay-A', name: 'A' },
  { id: 'Bay-B', name: 'B' },
  { id: 'Bay-C', name: 'C' },
  { id: 'Bay-D', name: 'D' },
  { id: UNAVAILABLE_BAY_ID, name: 'Enter Car Reg' },
]

const Modal = posed.div({
  css: {
    willChange: 'transform',
  },
  enter: {
    y: 0,
    transition: {
      duration: 500,
      ease: [0.19, 1, 0.22, 1],
    },
  },
  exit: {
    y: '100%',
    transition: {
      duration: 500,
      ease: [0.19, 1, 0.22, 1],
    },
  },
})

const Shade = posed.div({
  css: {
    willChange: 'opacity',
  },
  enter: { opacity: 1 },
  exit: { opacity: 0 },
})

const Home = ({ orderId, orderData, onArrivalConfirmation }) => {
  const [showBays, setShowBays] = useState(false)
  const [callingAPI, setCallingAPI] = useState(false)
  const [customerArrivalStatus, setCustomerArrivalStatus] = useState(false)

  function handleOrderDetailsClick() {
    window.open(
      `https://groceries.store.morrisons.com/orders/${orderId}/details`,
      '_blank'
    )
  }

  function handleArrivalClick() {
    if (env === 'prod') {
      if (dataLayer && dataLayer.push) {
        dataLayer.push({ event: 'alreadyHere' })
      }
    }
    setShowBays(true)
  }

  function handleBayClose() {
    setShowBays(false)
  }

  async function handleBayConfirmation(bayId) {
    if (!bayId) return
    if (env === 'prod') {
      if (dataLayer && dataLayer.push) {
        dataLayer.push({ event: 'confirm' })
      }
    }
    try {
      setCallingAPI(true)
      await onArrivalConfirmation(bayId, orderData[0])
      setShowBays(false)
      setCallingAPI(false)
      setCustomerArrivalStatus(true)
    } catch (error) {}
  }

  return (
    <div>
      <OrderInfoCard
        orderData={orderData}
        onArrivalClick={handleArrivalClick}
        arrivalStatus={customerArrivalStatus}
        onOrderDetailsClick={handleOrderDetailsClick}
      />
      <PoseGroup flipMove={false}>
        {showBays && [
          <Shade
            key="shade"
            className="fixed inset-0 z-40 bg-black-50"
            onClick={() => handleBayClose()}
          />,
          <Modal
            key="modal"
            className="fixed bottom-0 left-0 z-50 w-full lg:max-w-lg"
          >
            <BaySelector
              callingAPI={callingAPI}
              bays={bays}
              orderId={
                orderData && orderData.length ? orderData[0].orderId : undefined
              }
              onClose={handleBayClose}
              onBayConfirmation={handleBayConfirmation}
            />
          </Modal>,
        ]}
      </PoseGroup>
    </div>
  )
}

export default Home
